import { render, staticRenderFns } from "./RoleIndex.vue?vue&type=template&id=3c6f9318&scoped=true"
import script from "./RoleIndex.vue?vue&type=script&lang=js"
export * from "./RoleIndex.vue?vue&type=script&lang=js"
import style0 from "./RoleIndex.vue?vue&type=style&index=0&id=3c6f9318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6f9318",
  null
  
)

export default component.exports